import React from 'react';
import { useSelector } from 'react-redux';

import Tooltip from 'components/Tooltip';
import Button from 'components/V2/Button';
import { REQUEST_SANDBOX_TOOLTIP } from 'helper/constant';
import useRequestSandbox from 'hooks/useRequestSandbox';

import { selectLoggedInUser } from 'redux/selectors/auth';
import { selectSetupGuideStatus, selectUserRole } from 'redux/selectors/general';

import styles from './switchEnvironment.module.css';

// Navbar counterpart to the setup guide's "Request Sandbox" button, shown when no sandbox
// exists yet. Mirrors the guide's gating: owner-only, disabled until the company agreement
// is approved, and disabled after a request has already been sent.
function RequestSandboxButton() {
    const userRole = useSelector(selectUserRole);
    const customer = useSelector(selectLoggedInUser);
    const guideStatus = useSelector(selectSetupGuideStatus);
    const requestSandbox = useRequestSandbox();

    if (userRole !== 'company_owner') return null;

    const isAgreementApproved =
        !customer?.company?.meta_data?.agreement_status ||
        customer?.company?.meta_data?.agreement_status === 'approved';

    let disabled = false;
    let tooltip = '';

    if (!isAgreementApproved) {
        disabled = true;
        tooltip = REQUEST_SANDBOX_TOOLTIP.AGREEMENT_PENDING;
    } else if (guideStatus?.sentSandboxRequest) {
        disabled = true;
        tooltip = REQUEST_SANDBOX_TOOLTIP.REQUEST_SENT;
    }

    return (
        <Tooltip title={disabled ? tooltip : ''} placement="bottom" arrow>
            <span className={styles.requestSandboxWrapper}>
                <Button
                    intent="primary-outlined"
                    size="sm"
                    disabled={disabled}
                    onClick={() => requestSandbox()}
                >
                    Request Sandbox
                </Button>
            </span>
        </Tooltip>
    );
}

export default RequestSandboxButton;
